(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cybertown-inventory"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById('cybertown-search');
    const rows = document.querySelectorAll('.inventory-item-row');

    if (searchInput) {
      searchInput.addEventListener('input', function(e) {
        const term = e.target.value.toLowerCase().trim();
        
        rows.forEach(row => {
          const searchData = row.getAttribute('data-search');
          if (searchData.includes(term)) {
            row.classList.remove('is-hidden');
          } else {
            row.classList.add('is-hidden');
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impostores-ofertas"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // ====== CONFIG ======
    // ¡IMPORTANTE! Reemplaza estos con los "handles" de tus 4 productos.
    const handles = ['murr3y','unknown-y-andromeda','redd-impostor-supremo','paciente-0-y-novisor'];
    const DISCOUNT_CODE = 'KIT IMPOSTORES MALDITOS';
    const CART_REDIRECT_DELAY_MS = 900;
    // =====================

    const btn = document.getElementById('pv-bundle-btn');
    const msg = document.getElementById('pv-bundle-msg');

    if (!btn) return; // Si el botón no existe, no hacer nada.

    async function fetchVariantId(handle){
      const base = window.Shopify?.routes?.root || '/';
      const res  = await fetch(`${base}products/${encodeURIComponent(handle)}.js`, { headers:{'Accept':'application/json'} });
      if(!res.ok) throw new Error(`No se pudo cargar ${handle}`);
      const product = await res.json();
      const v = product?.variants?.[0];
      if(!v?.id) throw new Error(`Producto sin variante: ${handle}`);
      return v.id;
    }

    function setState(state, text){
      btn.classList.toggle('loading', state==='loading');
      btn.classList.toggle('success', state==='success');
      btn.classList.toggle('error',   state==='error');
      
      // Para deshabilitar una etiqueta <a>, usamos pointer-events
      btn.style.pointerEvents = state === 'loading' ? 'none' : 'auto';

      if(text){ msg.textContent = text; }
      msg.classList.toggle('error', state==='error');
      if(state!=='loading' && !text) msg.textContent = '';
    }

    function openDrawerIfAny(){
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      const drawer = document.querySelector('cart-drawer, cart-notification, cart-notification-drawer, mini-cart');
      if(drawer){
        try { drawer.open = true; } catch(_) {}
        document.body.dispatchEvent(new CustomEvent('added-to-cart', { bubbles:true }));
      }
    }

    function redirectTo(url){ window.location.href = url; }

    async function hasAllFourInCart(){
      const cart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
      const set = new Set(cart.items.map(i => i.handle));
      return handles.every(h => set.has(h));
    }

    async function addBundle(){
      setState('Cargando', 'Agregando productos...');
      try{
        const ids = await Promise.all(handles.map(fetchVariantId));
        const items = ids.map(id => ({ id, quantity: 1 }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if(!res.ok){
          const err = await res.json().catch(()=>({}));
          throw new Error(err?.description || 'No se pudo agregar el pack. Verificar stock.');
        }

        const allFour = await hasAllFourInCart();
        setState('success', allFour ? '¡KIT agregado con descuento!' : '¡4 Productos agregados!');
        openDrawerIfAny();

        setTimeout(() => {
          if (allFour) {
            redirectTo(`/discount/${encodeURIComponent(DISCOUNT_CODE)}?redirect=/cart`);
          } else {
            redirectTo('/cart');
          }
        }, CART_REDIRECT_DELAY_MS);

      } catch(e){
        setState('error', e.message || 'Error desconocido.');
      }
    }

    btn.addEventListener('click', (ev)=>{
      ev.preventDefault(); // Previene que el link navegue a otra página
      addBundle();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mods-fnf-offers"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // ====== CONFIG ======
    // ¡IMPORTANTE! Reemplaza estos con los "handles" de tus 4 productos de FNF.
    const handles = ['bob','boyfriend','tricky-the-clown','whitty'];
    const DISCOUNT_CODE = 'KIT MODS DE FNF';
    const CART_REDIRECT_DELAY_MS = 900;
    // =====================

    const btn = document.getElementById('pv-bundle-btn-fnf');
    const msg = document.getElementById('pv-bundle-msg-fnf');

    if (!btn) return;

    async function fetchVariantId(handle){
      const base = window.Shopify?.routes?.root || '/';
      const res  = await fetch(`${base}products/${encodeURIComponent(handle)}.js`, { headers:{'Accept':'application/json'} });
      if(!res.ok) throw new Error(`No se pudo cargar ${handle}`);
      const product = await res.json();
      const v = product?.variants?.[0];
      if(!v?.id) throw new Error(`Producto sin variante: ${handle}`);
      return v.id;
    }

    function setState(state, text){
      btn.classList.toggle('loading', state==='loading');
      btn.classList.toggle('success', state==='success');
      btn.classList.toggle('error',   state==='error');
      
      btn.style.pointerEvents = state === 'loading' ? 'none' : 'auto';

      if(text){ msg.textContent = text; }
      msg.classList.toggle('error', state==='error');
      if(state!=='loading' && !text) msg.textContent = '';
    }

    function openDrawerIfAny(){
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      const drawer = document.querySelector('cart-drawer, cart-notification, cart-notification-drawer, mini-cart');
      if(drawer){
        try { drawer.open = true; } catch(_) {}
        document.body.dispatchEvent(new CustomEvent('added-to-cart', { bubbles:true }));
      }
    }

    function redirectTo(url){ window.location.href = url; }

    async function hasAllFourInCart(){
      const cart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
      const set = new Set(cart.items.map(i => i.handle));
      return handles.every(h => set.has(h));
    }

    async function addBundle(){
      setState('loading', 'Agregando productos...');
      try{
        const ids = await Promise.all(handles.map(fetchVariantId));
        const items = ids.map(id => ({ id, quantity: 1 }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if(!res.ok){
          const err = await res.json().catch(()=>({}));
          throw new Error(err?.description || 'No se pudo agregar el pack. Verificar stock.');
        }

        const allFour = await hasAllFourInCart();
        setState('success', allFour ? '¡KIT agregado con descuento!' : '¡4 Productos agregados!');
        openDrawerIfAny();

        setTimeout(() => {
          if (allFour) {
            redirectTo(`/discount/${encodeURIComponent(DISCOUNT_CODE)}?redirect=/cart`);
          } else {
            redirectTo('/cart');
          }
        }, CART_REDIRECT_DELAY_MS);

      } catch(e){
        setState('error', e.message || 'Error desconocido.');
      }
    }

    btn.addEventListener('click', (ev)=>{
      ev.preventDefault();
      addBundle();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retro-plasti-offers"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // ====== CONFIGURACIÓN RETRO ======
    // ¡IMPORTANTE! Reemplaza los handles de abajo con los de tus PRODUCTOS RETRO
    const handles = [
      'winnie-clasico', 
      'winnie-jumbo', 
      'winnie-spider', 
      'winnie-impostor',
      'winnie-azul'
    ]; 
    const DISCOUNT_CODE = 'ENVIO_GRATIS_RETRO'; // Ponle este nombre exacto
    const CART_REDIRECT_DELAY_MS = 900;
    // =================================

    const botun = document.getElementById('rp-bundle-botun'); // ID Nuevo
    const msg = document.getElementById('rp-bundle-msg'); // ID Nuevo

    if (!botun) return;

    async function fetchVariantId(handle){
      const base = window.Shopify?.routes?.root || '/';
      const res  = await fetch(`${base}products/${encodeURIComponent(handle)}.js`, { headers:{'Accept':'application/json'} });
      if(!res.ok) throw new Error(`No se pudo cargar ${handle}`);
      const product = await res.json();
      const v = product?.variants?.[0];
      if(!v?.id) throw new Error(`Producto sin variante: ${handle}`);
      return v.id;
    }

    function setState(state, text){
      botun.classList.toggle('loading', state==='loading');
      botun.classList.toggle('success', state==='success');
      botun.classList.toggle('error',   state==='error');
      
      botun.style.pointerEvents = state === 'loading' ? 'none' : 'auto';

      if(text){ msg.textContent = text; }
      msg.classList.toggle('error', state==='error');
      if(state!=='loading' && !text) msg.textContent = '';
    }

    function openDrawerIfAny(){
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      const drawer = document.querySelector('cart-drawer, cart-notification, cart-notification-drawer, mini-cart');
      if(drawer){
        try { drawer.open = true; } catch(_) {}
        document.body.dispatchEvent(new CustomEvent('added-to-cart', { bubbles:true }));
      }
    }

    function redirectTo(url){ window.location.href = url; }

    async function hasAllFourInCart(){
      const cart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
      const set = new Set(cart.items.map(i => i.handle));
      return handles.every(h => set.has(h));
    }

    async function addBundle(){
      setState('Cargando', 'Agregando pack Retro...');
      try{
        const ids = await Promise.all(handles.map(fetchVariantId));
        const items = ids.map(id => ({ id, quantity: 1 }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if(!res.ok){
          const err = await res.json().catch(()=>({}));
          throw new Error(err?.description || 'No se pudo agregar el pack. Verificar stock.');
        }

        const allFour = await hasAllFourInCart();
        setState('success', allFour ? '¡Pack Retro agregado!' : '¡Productos agregados!');
        openDrawerIfAny();

        setTimeout(() => {
          if (allFour) {
            redirectTo(`/discount/${encodeURIComponent(DISCOUNT_CODE)}?redirect=/cart`);
          } else {
            redirectTo('/cart');
          }
        }, CART_REDIRECT_DELAY_MS);

      } catch(e){
        setState('error', e.message || 'Error desconocido.');
      }
    }

    botun.addEventListener('click', (ev)=>{
      ev.preventDefault();
      addBundle();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
